// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../.yarn/__virtual__/css-loader-virtual-7757297ec7/0/cache/css-loader-npm-6.11.0-d945f9f4c0-9e3665509f.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../.yarn/__virtual__/css-loader-virtual-7757297ec7/0/cache/css-loader-npm-6.11.0-d945f9f4c0-9e3665509f.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
NB: This exists at react-alice-carousel/lib/alice-carousel.css but the css shipped with alice-carousel sets
the line-height of all elements within an .alice-carousel__stage-item to 'initial' - which overrides the values we
set on a per font style basis. This seems to only affect the carousel when it is used in one of our own pages (versus
as a widget in a Forge generated page). In these instances the react-alice-carousel styles are injected after our own.
When used a widget, they're injected before. If they're loaded before any subsequent styles overwrite the rule. But
I can't figure out a way to control the load order of these things so rather than fight against the vagueries of style-loader
I'm just copying the react-alice-carousel styles and removing the offending line-height rule. Something to probably
revisit, but this component doesn't get updated that often so this should be pretty static.
*/

.alice-carousel .animated {
    animation-fill-mode: both;
}

.alice-carousel .animated-out {
    z-index: 1;
}

.alice-carousel .fadeOut {
    animation-name: fadeOut;
}

@keyframes fadeOut {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        visibility: hidden;
    }
}
.alice-carousel {
    position: relative;
    width: 100%;
    margin: auto;
    direction: ltr;
}

.alice-carousel__wrapper {
    position: relative;
    overflow-x: hidden;
    overflow-y: hidden;
    box-sizing: border-box;
    width: 100%;
    height: auto;
}

.alice-carousel__stage {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    transform-style: flat;
    -webkit-transform-style: flat;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
}
.alice-carousel__stage-item {
    position: relative;
    display: inline-block;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    vertical-align: top;
    white-space: normal;
    line-height: 0;
}
.alice-carousel__stage-item.__hidden {
    opacity: 0;
    overflow: hidden;
}

.alice-carousel__prev-btn,
.alice-carousel__next-btn {
    display: inline-block;
    box-sizing: border-box;
    width: 50%;
    padding: 10px 5px;
}
.alice-carousel__prev-btn [data-area]::after,
.alice-carousel__next-btn [data-area]::after {
    position: relative;
    content: attr(data-area);
    text-transform: capitalize;
}

.alice-carousel__prev-btn {
    text-align: right;
}

.alice-carousel__prev-btn-item,
.alice-carousel__next-btn-item {
    display: inline-block;
    cursor: pointer;
    padding: 5px;
    margin: 0;
    color: #465798;
}
.alice-carousel__prev-btn-item:hover,
.alice-carousel__next-btn-item:hover {
    color: darkred;
}
.alice-carousel__prev-btn-item.__inactive,
.alice-carousel__next-btn-item.__inactive {
    opacity: 0.4;
    pointer-events: none;
}

.alice-carousel__play-btn {
    position: absolute;
    top: 30px;
    left: 20px;
    display: inline-block;
}
.alice-carousel__play-btn:hover {
    cursor: pointer;
}
.alice-carousel__play-btn-wrapper {
    position: relative;
    width: 32px;
    height: 32px;
    padding: 10px;
    border-radius: 50%;
    background-color: #fff;
}

.alice-carousel__play-btn-item {
    position: absolute;
    width: 32px;
    height: 32px;
    cursor: pointer;
    border: 0;
    outline: none;
    background: transparent;
}
.alice-carousel__play-btn-item::before,
.alice-carousel__play-btn-item::after {
    position: absolute;
    pointer-events: none;
    display: block;
    width: 0;
    height: 0;
    content: '';
    transition: all 0.4s linear;
    border-width: 8px 0 8px 15px;
    border-style: solid;
    border-color: transparent;
    border-left-color: #465798;
}
.alice-carousel__play-btn-item::before {
    left: 5px;
    height: 14px;
}
.alice-carousel__play-btn-item::after {
    top: 7px;
    left: 18px;
}
.alice-carousel__play-btn-item.__pause::before,
.alice-carousel__play-btn-item.__pause::after {
    height: 30px;
    border-width: 0 0 0 10px;
}
.alice-carousel__play-btn-item.__pause::after {
    top: 0;
    left: 18px;
}

.alice-carousel__dots {
    margin: 30px 3px 5px;
    padding: 0;
    list-style: none;
    text-align: center;
}
.alice-carousel__dots > li {
    display: inline-block;
}
.alice-carousel__dots-item:not(.__custom) {
    width: 8px;
    height: 8px;
    cursor: pointer;
    border-radius: 50%;
    background-color: #e0e4fb;
}
.alice-carousel__dots-item:not(.__custom):not(:last-child) {
    margin-right: 20px;
}
.alice-carousel__dots-item:not(.__custom):hover,
.alice-carousel__dots-item:not(.__custom).__active {
    background-color: #6e7ebc;
}

.alice-carousel__slide-info {
    position: absolute;
    top: 20px;
    right: 20px;
    display: inline-block;
    padding: 5px 10px;
    color: #465798;
    border-radius: 5px;
    background-color: rgba(224, 228, 251, 0.6);
}
.alice-carousel__slide-info-item {
    vertical-align: middle;
    line-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/widgets/baseCarousel/alice-carousel-styles.css"],"names":[],"mappings":"AAAA;;;;;;;;;CASC;;AAED;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;QACV,kBAAkB;IACtB;AACJ;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,qBAAqB;IACrB,6BAA6B;IAC7B,2BAA2B;IAC3B,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,iBAAiB;AACrB;AACA;;IAEI,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,aAAa;IACb,uBAAuB;AAC3B;AACA;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,QAAQ;IACR,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,SAAS;IACT,YAAY;AAChB;AACA;IACI,QAAQ;IACR,UAAU;AACd;AACA;;IAEI,YAAY;IACZ,wBAAwB;AAC5B;AACA;IACI,MAAM;IACN,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,UAAU;IACV,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,0CAA0C;AAC9C;AACA;IACI,sBAAsB;IACtB,cAAc;AAClB","sourcesContent":["/*\nNB: This exists at react-alice-carousel/lib/alice-carousel.css but the css shipped with alice-carousel sets\nthe line-height of all elements within an .alice-carousel__stage-item to 'initial' - which overrides the values we\nset on a per font style basis. This seems to only affect the carousel when it is used in one of our own pages (versus\nas a widget in a Forge generated page). In these instances the react-alice-carousel styles are injected after our own.\nWhen used a widget, they're injected before. If they're loaded before any subsequent styles overwrite the rule. But\nI can't figure out a way to control the load order of these things so rather than fight against the vagueries of style-loader\nI'm just copying the react-alice-carousel styles and removing the offending line-height rule. Something to probably\nrevisit, but this component doesn't get updated that often so this should be pretty static.\n*/\n\n.alice-carousel .animated {\n    animation-fill-mode: both;\n}\n\n.alice-carousel .animated-out {\n    z-index: 1;\n}\n\n.alice-carousel .fadeOut {\n    animation-name: fadeOut;\n}\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n        visibility: hidden;\n    }\n}\n.alice-carousel {\n    position: relative;\n    width: 100%;\n    margin: auto;\n    direction: ltr;\n}\n\n.alice-carousel__wrapper {\n    position: relative;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    box-sizing: border-box;\n    width: 100%;\n    height: auto;\n}\n\n.alice-carousel__stage {\n    position: relative;\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n    transform-style: flat;\n    -webkit-transform-style: flat;\n    backface-visibility: hidden;\n    -webkit-backface-visibility: hidden;\n}\n.alice-carousel__stage-item {\n    position: relative;\n    display: inline-block;\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    vertical-align: top;\n    white-space: normal;\n    line-height: 0;\n}\n.alice-carousel__stage-item.__hidden {\n    opacity: 0;\n    overflow: hidden;\n}\n\n.alice-carousel__prev-btn,\n.alice-carousel__next-btn {\n    display: inline-block;\n    box-sizing: border-box;\n    width: 50%;\n    padding: 10px 5px;\n}\n.alice-carousel__prev-btn [data-area]::after,\n.alice-carousel__next-btn [data-area]::after {\n    position: relative;\n    content: attr(data-area);\n    text-transform: capitalize;\n}\n\n.alice-carousel__prev-btn {\n    text-align: right;\n}\n\n.alice-carousel__prev-btn-item,\n.alice-carousel__next-btn-item {\n    display: inline-block;\n    cursor: pointer;\n    padding: 5px;\n    margin: 0;\n    color: #465798;\n}\n.alice-carousel__prev-btn-item:hover,\n.alice-carousel__next-btn-item:hover {\n    color: darkred;\n}\n.alice-carousel__prev-btn-item.__inactive,\n.alice-carousel__next-btn-item.__inactive {\n    opacity: 0.4;\n    pointer-events: none;\n}\n\n.alice-carousel__play-btn {\n    position: absolute;\n    top: 30px;\n    left: 20px;\n    display: inline-block;\n}\n.alice-carousel__play-btn:hover {\n    cursor: pointer;\n}\n.alice-carousel__play-btn-wrapper {\n    position: relative;\n    width: 32px;\n    height: 32px;\n    padding: 10px;\n    border-radius: 50%;\n    background-color: #fff;\n}\n\n.alice-carousel__play-btn-item {\n    position: absolute;\n    width: 32px;\n    height: 32px;\n    cursor: pointer;\n    border: 0;\n    outline: none;\n    background: transparent;\n}\n.alice-carousel__play-btn-item::before,\n.alice-carousel__play-btn-item::after {\n    position: absolute;\n    pointer-events: none;\n    display: block;\n    width: 0;\n    height: 0;\n    content: '';\n    transition: all 0.4s linear;\n    border-width: 8px 0 8px 15px;\n    border-style: solid;\n    border-color: transparent;\n    border-left-color: #465798;\n}\n.alice-carousel__play-btn-item::before {\n    left: 5px;\n    height: 14px;\n}\n.alice-carousel__play-btn-item::after {\n    top: 7px;\n    left: 18px;\n}\n.alice-carousel__play-btn-item.__pause::before,\n.alice-carousel__play-btn-item.__pause::after {\n    height: 30px;\n    border-width: 0 0 0 10px;\n}\n.alice-carousel__play-btn-item.__pause::after {\n    top: 0;\n    left: 18px;\n}\n\n.alice-carousel__dots {\n    margin: 30px 3px 5px;\n    padding: 0;\n    list-style: none;\n    text-align: center;\n}\n.alice-carousel__dots > li {\n    display: inline-block;\n}\n.alice-carousel__dots-item:not(.__custom) {\n    width: 8px;\n    height: 8px;\n    cursor: pointer;\n    border-radius: 50%;\n    background-color: #e0e4fb;\n}\n.alice-carousel__dots-item:not(.__custom):not(:last-child) {\n    margin-right: 20px;\n}\n.alice-carousel__dots-item:not(.__custom):hover,\n.alice-carousel__dots-item:not(.__custom).__active {\n    background-color: #6e7ebc;\n}\n\n.alice-carousel__slide-info {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    display: inline-block;\n    padding: 5px 10px;\n    color: #465798;\n    border-radius: 5px;\n    background-color: rgba(224, 228, 251, 0.6);\n}\n.alice-carousel__slide-info-item {\n    vertical-align: middle;\n    line-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
